import React from 'react';
import { FormattedMessage } from 'react-intl';
import VM from 'scratch-vm';

import musicImage from './music.png';
import musicInsetImage from './music-small.svg';
import penImage from './pen.png';
import penInsetImage from './pen-small.svg';
import videoImage from './video-sensing.png';
import videoInsetImage from './video-sensing-small.svg';
import translateImage from './translate.png';
import translateInsetImage from './translate-small.png';
import microbitImage from './microbit.png';
import ev3Image from './ev3.png';
import wedoImage from './wedo.png';
import speechImage from './speech.png'
import speech2textSamll from './speech2text-small.png'
import text2speechImage from './text2speech.png';
import text2speechInsetImage from './text2speech-small.svg';
import makeymakeyImage from './makeymakey.png';
import makeymakeyInsetImage from './makeymakey-small.svg';

import microbitPeripheralImage from './peripheral-connection/microbit/microbit-illustration.svg';
import microbitMenuImage from './peripheral-connection/microbit/microbit-small.svg';
import ev3PeripheralImage from './peripheral-connection/ev3/ev3-hub-illustration.svg';
import ev3MenuImage from './peripheral-connection/ev3/ev3-small.svg';
import wedoPeripheralImage from './peripheral-connection/wedo/wedo-illustration.svg';
import wedoMenuImage from './peripheral-connection/wedo/wedo-small.svg';
import wedoButtonImage from './peripheral-connection/wedo/wedo-button-illustration.svg';

import daliImage from './daliImg.png';
import daliIcon from './daliIcon.png';
import extSensorIcon from './ext-sensor.svg';
import extSensorImage from './ext-sensorImg.png';
import extWirelessIcon from './ext-wireless.png';
import extWirelessImage from './ext-wirelessImg.png';
import AIIcon from './AIIcon.svg';
import AIImg from './AIImg.png';

import MFImg from './MF.png';
import MFIcon from './MF_icon.png';

import DragonBoatImg from './Dragon_boat.png';
import DragonBoatIcon from './Dragon_boat_icon.png';

import MailunImg from './mailun.svg';
import MailunIcon from './mailun-icon.svg';


import DuojiImg from './ext_duoji.png';
import DuojiIcon from './ext_duoji_icon.png';

import iotImg from './ext_iot_image.svg';
import iotIcon from './ext_iot.svg';

export default [
    {
        name: (
            <FormattedMessage
                defaultMessage="ExtSensor"
                description="Name for the 'ExtSensor' extension"
                id="gui.extension.extSensor.name"
            />
        ),
        extensionId: 'extSensor',
        iconURL: extSensorImage,
        insetIconURL: extSensorIcon,
        description:(
            <FormattedMessage
                defaultMessage="获取更多传感器编程模块、如循迹卡、激光传感器、手势传感器、扫码摄像头等。"
                id="EXT_SENSOR_DESCRIBE"
            />
        ),
        featured: true,
        robotArray: ['E6', 'M6', 'C6', 'E3', 'E7',"M5"]
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="ExtWireless"
                description="Name for the 'ExtWireless' extension"
                id="gui.extension.extWireless.name"
            />
        ),
        extensionId: 'extWireless',
        iconURL: extWirelessImage,
        insetIconURL: extWirelessIcon,
        description: (
            <FormattedMessage
                defaultMessage="此扩展能使用更多无线控制方式。"
                id="EXT_WIFI_DESCRIBE"
            />
        ),
        featured: true,
        robotArray: ['E6', 'E3', 'M6', 'C6', 'C1']
    },
    {
        name: 'AI',
        extensionId: 'AI',
        // collaborator: 'Amazon Web Services',
        iconURL: AIImg,
        insetIconURL: AIIcon,
        description: (
            <FormattedMessage
                defaultMessage="AI视觉模块，支持多种视觉识别与语音识别，支持本地图像学习功能。"
                id="EXT_AI_DESCRIBE"
            />
        ),
        featured: true,
        // internetConnectionRequired: true
    },
    // {
    //     name: "舵机",
    //     extensionId: 'extServo',
    //     iconURL: DuojiImg,
    //     insetIconURL: DuojiIcon,
    //     description: "获取更多种类舵机控制功能，如小型舵机、数字舵机、伺服舵机等。",
    //     featured: true,
    //     robotArray: ['E6', 'M6']
    // },
    {
        name: "IoT",
        extensionId: 'extIot',
        iconURL: iotImg,
        insetIconURL: iotIcon,
        description: (
            <FormattedMessage
                defaultMessage="IoT模块，支持与中鸣物联网平台通讯，支持标准MQTT协助订阅和发布。"
                id="EXT_IOT_DESCRIBE"
            />
        ),
        featured: true,
        robotArray: ['E6', 'M6', 'C6', 'E3', 'E7']
    },
    {
        name: (
            <FormattedMessage
                id="CATEGORY_RUBIK_CUBE"
            />
        ),
        extensionId: 'MF',
        iconURL: MFImg,
        insetIconURL: MFIcon,
        description: (
            <FormattedMessage
                id="CATEGORY_RUBIK_CUBE"
            />
        ),
        featured: true,
        robotArray: ['E7']
    },
    {
        name: (
            <FormattedMessage
                id="CATEGORY_DRAGON_BOAT"
            />
        ),
        extensionId: 'DragonBoat',
        iconURL: DragonBoatImg,
        insetIconURL: DragonBoatIcon,
        description: (
            <FormattedMessage
                id="CATEGORY_DRAGON_BOAT"
            />
        ),
        featured: true,
        robotArray: ['E7'],
    },
    {
        name: (
            <FormattedMessage
                id="CATEGORY_WHEAT_WHEEL"
            />
        ),
        extensionId: 'Mecanumwheel',
        iconURL: MailunImg,
        insetIconURL: MailunIcon,
        description: (
            <FormattedMessage
                id="CATEGORY_WHEAT_WHEEL"
            />
        ),
        featured: true,
        robotArray: ['E7'],
    },
    // {
    //     name: (
    //         <FormattedMessage
    //             defaultMessage="DALI"
    //             description="Name for the 'DALI' extension"
    //             id="gui.extension.dali.name"
    //         />
    //     ),
    //     extensionId: 'dali',
    //     iconURL: daliImage,
    //     insetIconURL: daliIcon,
    //     description: (
    //         <FormattedMessage
    //             defaultMessage="Wifi smart light fixture."
    //             description="Description for the 'DALI' extension"
    //             id="gui.extension.dali.description"
    //         />
    //     ),
    //     featured: true,
    //     robotArray: ['E6', 'M6', 'E3', 'E7']
    // },
    {
        name: (
            <FormattedMessage
                defaultMessage="Music"
                description="Name for the 'Music' extension"
                id="gui.extension.music.name"
            />
        ),
        extensionId: 'music',
        iconURL: musicImage,
        insetIconURL: musicInsetImage,
        description: (
            <FormattedMessage
                defaultMessage="Play instruments and drums."
                description="Description for the 'Music' extension"
                id="gui.extension.music.description"
            />
        ),
        featured: true
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="Pen"
                description="Name for the 'Pen' extension"
                id="gui.extension.pen.name"
            />
        ),
        extensionId: 'pen',
        iconURL: penImage,
        insetIconURL: penInsetImage,
        description: (
            <FormattedMessage
                defaultMessage="Draw with your sprites."
                description="Description for the 'Pen' extension"
                id="gui.extension.pen.description"
            />
        ),
        featured: true
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="Video Sensing"
                description="Name for the 'Video Sensing' extension"
                id="gui.extension.videosensing.name"
            />
        ),
        extensionId: 'videoSensing',
        iconURL: videoImage,
        insetIconURL: videoInsetImage,
        description: (
            <FormattedMessage
                defaultMessage="Sense motion with the camera."
                description="Description for the 'Video Sensing' extension"
                id="gui.extension.videosensing.description"
            />
        ),
        featured: true
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="Text to Speech"
                description="Name for the Text to Speech extension"
                id="gui.extension.text2speech.name"
            />
        ),
        extensionId: 'text2speech',
        // collaborator: 'Amazon Web Services',
        iconURL: text2speechImage,
        insetIconURL: text2speechInsetImage,
        description: (
            <FormattedMessage
                defaultMessage="Make your projects talk."
                description="Description for the Text to speech extension"
                id="gui.extension.text2speech.description"
            />
        ),
        featured: true,
        // internetConnectionRequired: true
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="Speech to Text"
                description="Name for the Speech to Text extension"
                id="gui.extension.speech2Text.name"
            />
        ),
        extensionId: 'speech2text',
        // collaborator: 'Amazon Web Services',
        iconURL: speechImage,
        insetIconURL: speech2textSamll,
        description: (
            <FormattedMessage
                defaultMessage="Speech to Text"
                description="Description for the speech to Text extension"
                id="gui.extension.speech2Text.description"
            />
        ),
        featured: true,
        // internetConnectionRequired: true
    },
    {
        name: (
            <FormattedMessage
                defaultMessage="Translate"
                description="Name for the Translate extension"
                id="gui.extension.translate.name"
            />
        ),
        extensionId: 'translate',
        // collaborator: 'Google',
        iconURL: translateImage,
        insetIconURL: translateInsetImage,
        description: (
            <FormattedMessage
                defaultMessage="Translate text into many languages."
                description="Description for the Translate extension"
                id="gui.extension.translate.description"
            />
        ),
        featured: true,
        // internetConnectionRequired: true
    },
    // {
    //     name: 'Makey Makey',
    //     extensionId: 'makeymakey',
    //     collaborator: 'JoyLabz',
    //     iconURL: makeymakeyImage,
    //     insetIconURL: makeymakeyInsetImage,
    //     description: (
    //         <FormattedMessage
    //             defaultMessage="Make anything into a key."
    //             description="Description for the 'Makey Makey' extension"
    //             id="gui.extension.makeymakey.description"
    //         />
    //     ),
    //     featured: true
    // },
    // {
    //     name: 'micro:bit',
    //     extensionId: 'microbit',
    //     // collaborator: 'micro:bit',
    //     iconURL: microbitImage,
    //     insetIconURL: microbitMenuImage,
    //     description: (
    //         <FormattedMessage
    //             defaultMessage="Connect your projects with the world."
    //             description="Description for the 'micro:bit' extension"
    //             id="gui.extension.microbit.description"
    //         />
    //     ),
    //     featured: true,
    //     disabled: false,
    //     // bluetoothRequired: true,
    //     // launchPeripheralConnectionFlow: true,
    //     // useAutoScan: false,
    //     peripheralImage: microbitPeripheralImage,
    //     smallPeripheralImage: microbitMenuImage,
    //     connectingMessage: (
    //         <FormattedMessage
    //             defaultMessage="Connecting"
    //             description="Message to help people connect to their micro:bit."
    //             id="gui.extension.microbit.connectingMessage"
    //         />
    //     ),
    //     helpLink: 'https://scratch.mit.edu/microbit'
    // },
    // {
    //     name: 'LEGO MINDSTORMS EV3',
    //     extensionId: 'ev3',
    //     collaborator: 'LEGO',
    //     iconURL: ev3Image,
    //     insetIconURL: ev3MenuImage,
    //     description: (
    //         <FormattedMessage
    //             defaultMessage="Build interactive robots and more."
    //             description="Description for the 'LEGO MINDSTORMS EV3' extension"
    //             id="gui.extension.ev3.description"
    //         />
    //     ),
    //     featured: true,
    //     disabled: false,
    //     bluetoothRequired: true,
    //     launchPeripheralConnectionFlow: true,
    //     useAutoScan: false,
    //     peripheralImage: ev3PeripheralImage,
    //     smallPeripheralImage: ev3MenuImage,
    //     connectingMessage: (
    //         <FormattedMessage
    //             defaultMessage="Connecting. Make sure the pin on your EV3 is set to 1234."
    //             description="Message to help people connect to their EV3. Must note the PIN should be 1234."
    //             id="gui.extension.ev3.connectingMessage"
    //         />
    //     ),
    //     helpLink: 'https://scratch.mit.edu/ev3'
    // },
    // {
    //     name: 'LEGO WeDo 2.0',
    //     extensionId: 'wedo2',
    //     collaborator: 'LEGO',
    //     iconURL: wedoImage,
    //     insetIconURL: wedoMenuImage,
    //     description: (
    //         <FormattedMessage
    //             defaultMessage="Build with motors and sensors."
    //             description="Description for the 'LEGO WeDo 2.0' extension"
    //             id="gui.extension.wedo2.description"
    //         />
    //     ),
    //     featured: true,
    //     disabled: false,
    //     bluetoothRequired: true,
    //     launchPeripheralConnectionFlow: true,
    //     useAutoScan: true,
    //     peripheralImage: wedoPeripheralImage,
    //     smallPeripheralImage: wedoMenuImage,
    //     peripheralButtonImage: wedoButtonImage,
    //     connectingMessage: (
    //         <FormattedMessage
    //             defaultMessage="Connecting"
    //             description="Message to help people connect to their WeDo."
    //             id="gui.extension.wedo2.connectingMessage"
    //         />
    //     ),
    //     helpLink: 'https://scratch.mit.edu/wedo'

    // }
    // {
    //     name: "AI作诗",
    //     extensionId: 'AIcomposePoem',
    //     // collaborator: 'Amazon Web Services',
    //     iconURL: speechImage,
    //     insetIconURL: speech2textSamll,
    //     description: "AI作诗",
    //     featured: true
    // },
    // {
    //     name: 'FaceAI',
    //     extensionId: 'FaceAI',
    //     // collaborator: 'Amazon Web Services',
    //     iconURL: speechImage,
    //     insetIconURL: speech2textSamll,
    //     description: "FaceAI",
    //     featured: true,
    //     // internetConnectionRequired: true
    // },
];
